export function getToggleButtonClassName(
	currIndex: number,
	totalItems: number
) {
	if (currIndex === 0) return "first";
	else if (currIndex === totalItems) return "last";
	else return "inner";
}